import { NgModule } from '@angular/core';
import { ClientPageAddonComponentsModule } from './client-page-addon-components.module';
import { ClientPageAddonRoutingModule } from './client-page-addon-routing.module';

@NgModule({
  imports: [ClientPageAddonRoutingModule, ClientPageAddonComponentsModule],
  exports: [ClientPageAddonComponentsModule],
})
export class ClientPageAddonModule {}
